module.exports = __webpack_public_path__ + "static/media/WorkdayLogo.31b6cecb.png";